import { createReducer, on } from "@ngrx/store";
import * as BugReportActions from "./bug-report.actions";
import type { BugReportState } from "./bug-report.models";

export const initialState: BugReportState = {
  submitting: false,
  lastSubmitted: null,
  reports: [],
  loading: false,
  error: null,
  success: false,
};

export const bugReportReducer = createReducer(
  initialState,

  on(BugReportActions.BugReportClearStatus, (state) => ({
    ...state,
    error: null,
    success: false,
  })),

  on(BugReportActions.BugReportFetchRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(BugReportActions.BugReportFetchSuccess, (state, { reports }) => ({
    ...state,
    reports,
    loading: false,
    error: null,
  })),

  on(BugReportActions.BugReportFetchFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(BugReportActions.BugReportUpdateStatusRequest, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(BugReportActions.BugReportUpdateStatusSuccess, (state, { report }) => ({
    ...state,
    loading: false,
    error: null,
    reports: state.reports.map((existing) => existing.id === report.id ? report : existing),
  })),

  on(BugReportActions.BugReportUpdateStatusFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(BugReportActions.BugReportCreateRequest, (state) => ({
    ...state,
    submitting: true,
    error: null,
    success: false,
  })),

  on(BugReportActions.BugReportCreateSuccess, (state, { report }) => ({
    ...state,
    submitting: false,
    lastSubmitted: report,
    reports: [report, ...state.reports],
    error: null,
    success: true,
  })),

  on(BugReportActions.BugReportCreateFailure, (state, { error }) => ({
    ...state,
    submitting: false,
    error,
    success: false,
  })),
);
